import { createApp } from 'vue'
import App from './App.vue'
import { AgGridVue } from 'ag-grid-vue3';
import router from "./router"; // 라우터 가져오기
import { createPinia } from "pinia";
import axiosInstance from "@/api/axios";

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import "ag-grid-community/styles/ag-grid.css"; // 기본 그리드 스타일
import "ag-grid-community/styles/ag-theme-alpine.css"; // 테마 스타일
// Bootstrap CSS 추가
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@/assets/styles/common.css'
import '@/assets/styles/compact.css' // 전역 밀도 레이어 — 여백 압축 일괄 관리
import phoneMask from './directives/phoneMask.js'
import { installErrorReporter } from '@/utils/errorReporter' // 전역 에러 → 텔레그램 (2026-07-15)



const app = createApp(App)
/*
app.use((req,res)=>{
  res.dirrect(301,'http://smartwork.sw-mht.co.kr'+req.originalUrl);

});

*/
app.directive('phonemask', phoneMask)
app.config.globalProperties.$axios = axiosInstance;
app.use(createPinia());
app.use(router);
app.use(ElementPlus, { size: 'small' }); // 전역 밀도: 버튼·인풋 등 기본 small (2026-08-01)
app.component('AgGridVue', AgGridVue);
app.component('QuillEditor', QuillEditor)

// 전역 에러 리포터 — Vue/window/promise 에러를 /api/client-error/ 로 전송
installErrorReporter(app, router);

app.mount('#app');

// PWA Service Worker 등록 + 자동 업데이트
// - 앱 복귀(visibilitychange)·30분 주기로 새 배포 확인
// - 새 SW가 컨트롤을 잡으면(=배포됨): 백그라운드면 즉시 새로고침,
//   사용 중이면 확인 후 새로고침 (입력 중 데이터 유실 방지)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('SW registered:', reg.scope);
        const checkUpdate = () => reg.update().catch(() => {});
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkUpdate();
        });
        setInterval(checkUpdate, 30 * 60 * 1000);
      })
      .catch(err => console.warn('SW registration failed:', err));

    // 최초 설치(controller 없던 상태)는 제외하고, 교체 시에만 반영
    let hadController = !!navigator.serviceWorker.controller;
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController) { hadController = true; return; }
      if (refreshing) return;
      refreshing = true;
      if (document.visibilityState === 'hidden') {
        window.location.reload();
      } else if (window.confirm('새 버전이 배포되었습니다. 지금 새로고침할까요?')) {
        window.location.reload();
      } else {
        refreshing = false; // 거절 시 다음 기회(앱 복귀 등)에 다시
      }
    });
  });
}

